var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"language row-center ais"},_vm._l((_vm.languages),function(oLang){return (oLang != _vm.$i18n.locale)?_c('div',{staticClass:"flags"},[_c('router-link',{staticClass:"lang",attrs:{"to":{ name: _vm.$route.name, params: { lang: oLang } }}},[_c('span',[_vm._v(_vm._s(oLang))])])],1):_vm._e()}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9834c99a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view-parts/footer-parts/idioma.vue
// module id = null
// module chunks = 